export default "__VITE_ASSET__KW7qOnxS__"